import React, { useEffect, useState } from "react";
import Pagination from "common/Pagination";
import CustomModal from "common/CustomModal";
import { useModalGac } from "hooks/useModalGac";
import { toast } from "react-hot-toast";
import { ReactComponent as Edit } from "assets/icons/edit-button.svg";
import { ReactComponent as Delete } from "assets/icons/delete.svg";
import { getAllNews } from "service/ServiceNews";
import NewsForm from "../../features/news/ui/components/NewsForm";
import updateNews from "../../features/news/usecases/updateNews";
import deleteNews from "../../features/news/usecases/deleteNews";

import "./form.css";

const ITEMS_PER_PAGE = 10;

const OpcNews = ({ search }) => {
  const [allNews, setAllNews] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const [isOpenModalDelete, openModalDelete, closeModalDelete] =
    useModalGac(false);

  const [isOpenModalEdit, openModalEdit, closeModalEdit] = useModalGac(false);

  const [itemSelect, setItemSelect] = useState(null);

  const information = async () => {
    try {
      const response = await getAllNews();
      setAllNews(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    information();
  }, []);

  // Filtrar noticias
  const filteredNews = allNews.filter((news) => {
    const searchText = search.toLowerCase().trim();

    if (!searchText) return true;

    return (
      news.titulo?.toLowerCase().includes(searchText) ||
      news.etiqueta?.toLowerCase().includes(searchText) ||
      news.tipo?.toLowerCase().includes(searchText) ||
      news.descripcion?.toLowerCase().includes(searchText)
    );
  });

  // Volver a la primera página cuando cambia la búsqueda
  useEffect(() => {
    setCurrentPage(0);
  }, [search]);

  // Paginación
  const startIndex = currentPage * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  const currentTickets = filteredNews.slice(startIndex, endIndex);

  const onSubmitItemEdit = async (data) => {
    try {
      await updateNews(data.id || itemSelect?.id, data, itemSelect);

      toast.success("Noticia actualizada correctamente");

      await information();

      closeModalEdit();
    } catch (error) {
      console.error(error);
      toast.error(
        error?.message || "No se ha podido actualizar, intentelo de nuevo",
      );
    }
  };

  const handleDelete = async (id, id_img) => {
    try {
      await deleteNews(id, id_img);

      toast.success("Noticia eliminada correctamente");

      await information();

      closeModalDelete();
    } catch (error) {
      console.log(error);
      toast.error("Ocurrio un error, intentelo de nuevo");
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItem = (type, item) => {
    setItemSelect(item);

    switch (type) {
      case "EDIT":
        openModalEdit();
        break;

      case "DELETE":
        openModalDelete();
        break;

      default:
        break;
    }
  };

  return (
    <>
      <div className="table-wrapper">
        <table className="table-history">
          <thead>
            <tr>
              <th>#</th>
              <th>Imagen</th>
              <th>Categoria</th>
              <th>Titulo</th>
              <th>Descripción</th>
              <th>Tipo</th>
              <th>Opciones</th>
            </tr>
          </thead>

          <tbody>
            {currentTickets?.map((news, index) => (
              <tr key={news.id}>
                <td>
                  <input
                    type="checkbox"
                    id={`${news.id} miCheckbox`}
                    className="mi-checkbox"
                  />

                  <label
                    htmlFor={`${news.id} miCheckbox`}
                    className="checkbox-label"
                  >
                    {startIndex + index + 1}
                  </label>
                </td>

                <td>
                  <img
                    loading="lazy"
                    src={
                      news.img && news.img.includes("pdf")
                        ? news.preview
                        : news.img
                    }
                    alt={news.titulo}
                    className="img-table"
                  />
                </td>

                <td>{news.etiqueta}</td>

                <td>{news.titulo}</td>

                <td>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: news?.descripcion?.slice(0, 60),
                    }}
                  />
                </td>

                <td>{news.tipo}</td>

                <td
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "5px",
                  }}
                >
                  <button
                    className="primaryBtn"
                    onClick={() => handleItem("EDIT", news)}
                  >
                    <Edit
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </button>

                  <button
                    className="deleteBtn"
                    onClick={() => handleItem("DELETE", news)}
                  >
                    <Delete
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </button>
                </td>
              </tr>
            ))}

            {currentTickets.length === 0 && (
              <tr>
                <td colSpan="7" className="no-results">
                  No se encontraron noticias.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        totalItems={filteredNews.length}
        itemsPerPage={ITEMS_PER_PAGE}
        onPageChange={handlePageChange}
      />

      <CustomModal isOpen={isOpenModalEdit} closeModal={closeModalEdit}>
        {/* El formulario se monta recién al abrir el modal: react-hook-form
            solo toma defaultValues al montar, por lo que renderizarlo siempre
            (con itemSelect = null) dejaba el formulario vacío en edición. */}
        {isOpenModalEdit && itemSelect && (
          <NewsForm
            key={itemSelect.id}
            mode="edit"
            defaultValues={itemSelect}
            onSubmit={onSubmitItemEdit}
          />
        )}
      </CustomModal>

      <CustomModal isOpen={isOpenModalDelete} closeModal={closeModalDelete}>
        <div
          className="modalComponent"
          style={{
            marginTop: "50%",
          }}
        >
          <div className="modalHeader">
            <h5 className="heading">Eliminar noticia</h5>
          </div>

          <button className="closeBtn" onClick={closeModalDelete}>
            x
          </button>

          <div className="modalContentComponent">
            ¿Esta seguro que desea eliminar esta noticia?
            <div className="modalActionsComponent">
              <div className="actionsContainer">
                <button
                  className="deleteBtn"
                  onClick={() => handleDelete(itemSelect.id, itemSelect.id_img)}
                >
                  Si, eliminar
                </button>

                <button className="cancelBtn" onClick={closeModalDelete}>
                  No, cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default OpcNews;
